<template>
  <div>
    <b-autocomplete
      v-model="newUser.userId"
      :error-messages="getErrorMessages(v$.userId)"
      :items="allUsers"
      autocompleteStyle="width: 100%"
      class="mb-4"
      item-title="name"
      item-value="id"
      placeholder="Оберіть користувача"
      @blur="v$.userId.$touch()" />
  </div>
</template>

<script>
import { required, useStore, useVuelidate } from '@/plugins/index.js'
import { computed, reactive } from 'vue'
import { getErrorMessages } from '@/utils/helpers.js'
import { setSnackbar } from 'best-modules/plugins'
import { fillDirectory, getDirectory } from '@/directory/index.ts'
import { userChange } from '@/requests/user'

export default {
  name: 'ChangeUser',
  methods: { getErrorMessages },
  async setup() {
    const store = useStore()

    await fillDirectory('userList')

    const currentUser = computed(() => store.state.user.userData)
    const allUsers = computed(() => {
      return getDirectory('userList').filter(u => {
        return u.id !== currentUser.value.id
      })
    })

    const newUser = reactive({
      userId: null,
    })

    const rules = computed(() => {
      return {
        userId: { required },
      }
    })

    const v$ = useVuelidate(rules, newUser)

    const submit = () => {
      return userChange(newUser.userId).then(res => {
        store.commit('user/setUserData', res)
        store.dispatch('documentCounts/getDocumentCounts')
        setSnackbar({ text: 'Користувача успішно змінено' })

        return res
      })
    }

    return {
      v$,
      submit,
      newUser,
      allUsers,
    }
  },
}
</script>

<style scoped></style>
